import { render, staticRenderFns } from "./AngebotPreise.vue?vue&type=template&id=07df34da&scoped=true&"
import script from "./AngebotPreise.vue?vue&type=script&lang=js&"
export * from "./AngebotPreise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07df34da",
  null
  
)

export default component.exports